// import { scroller } from 'react-scroll';

import {
    REMOVE_SECTION_REQUESTED,
    REMOVE_SECTION_COMPLETED,
    REMOVE_SECTION_ERROR,
} from './types';

// import getContent from '../../services/content/getContent';

const addSectionAction = async slug => async (dispatch) => {
    dispatch({
        type: REMOVE_SECTION_REQUESTED,
    });

    try {
        // const content = getContent(['reasons-why'], [sectionTitle]);
        // console.log('sectionTitle', sectionTitle);
        // console.log('content', content);
        return dispatch({
            type: REMOVE_SECTION_COMPLETED,
            payload: slug,
        });
    } catch (err) {
        return dispatch({
            type: REMOVE_SECTION_ERROR,
            payload: err,
        });
    }
};

export default addSectionAction;
